export default function Index() {
  return (
    <div>
      <h1>Index page</h1>
    </div>
  )
}
